// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import translate from "@insite/client-framework/Translate";
import { TaxExemptionCertificateModel } from "@store/Framework/Types/ApiModels";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTable, { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DynamicDropdown, { OptionObject } from "@insite/mobius/DynamicDropdown";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { DataTableBody, DataTableCell, DataTableHead, DataTableHeader, DataTableRow } from "@insite/mobius/index";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ListItem, { ListItemProps, UnorderedList, UnorderedListProps } from "@insite/mobius/Lists";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea from "@insite/mobius/TextArea";
import TextField from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import MinusCircleFill from "@store/Library/Components/Toolkit/Icons/MinusCircle/MinusCircleFill";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import Button from "@store/MobiusOverrides/Button/Button";
import FileUpload from "@store/MobiusOverrides/FileUpload/FileUpload";
import ReCaptcha from "@store/Overrides/Components/ReCaptcha";
import useForceUpdate from "@store/Framework/Common/Hooks/useForceUpdate";
import { convertFileToBase64 } from "@store/Framework/Common/Utilities/convertFileToBase64";
import { TECNotificationApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import loadTECFinanceCompanies from "@store/Framework/Store/Greif/Data/TECFinanceCompanies/Handlers/LoadTECFinanceCompanies";
import loadMessages from "@insite/client-framework/Store/Data/Messages/Handlers/LoadMessages";
import { getTECFinanceCompaniesDataView } from "@store/Framework/Store/Greif/Data/TECFinanceCompanies/TECFinanceCompaniesSelectors";
import clearTECNotificationForm from "@store/Framework/Store/Greif/Pages/TECNotification/Handlers/ClearTECNotificationForm";
import submitTECNotificationForm from "@store/Framework/Store/Greif/Pages/TECNotification/Handlers/SubmitTECNotificationForm";
import FieldLabelAndTip from "@store/Library/Components/FieldLabelAndTip";
import { tableGetEllipsisCellProps } from "@store/Themes/common/props/table";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { makeHandlerChainAwaitable } from "@toolkit/Modules/client-framework/HandlerCreator";
import React, { RefObject, useContext, useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";

interface OwnProps {
    id: string;
    formVariant: "support" | "new";
    fileImportFormat: string;
    firstNameRequired: boolean;
    lastNameRequired: boolean;
    financeCompanyRequired: boolean;
    isFinanceCompanyDropdown?: boolean;
    fileRequired: boolean;
    allowMultipleFiles: boolean;
    successMessage: string;
    messageRequired: boolean;
    submitButtonText: string;
    certificateData?: TaxExemptionCertificateModel;
    linkBack?: PageLinkModel;
    extendedStyles?: TaxExemptionCertificateFormStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    currentSession: state.context.session,
    countries: getCurrentCountries(state),
    currentBillTo: getCurrentBillToState(state).value,
    financeCompaniesDataView: getTECFinanceCompaniesDataView(state, {}),
});

const mapDispatchToProps = {
    submitTECNotificationForm,
    clearTECNotificationForm,
    loadTECFinanceCompanies,
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: React.RefObject<ReCAPTCHA> },
        boolean
    >(validateReCaptcha),
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

type Validator = () => boolean;

type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

export interface TaxExemptionCertificateFormStyles {
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    errorsListTitle?: TypographyPresentationProps;
    errorsList?: UnorderedListProps;
    errorsListItem?: ListItemProps;
    errorsLink?: LinkPresentationProps;
    gridContainer?: GridContainerProps;
    formGridItem?: GridItemProps;
    fieldsFullGridItem?: GridItemProps;
    fieldsHalfGridItem?: GridItemProps;
    customerNameItem?: GridItemProps;
    customerNumberItem?: GridItemProps;
    filesGridItem?: GridItemProps;
    filesItemWrapper?: FlexWrapperPresentationProps;
    addActionLink?: LinkPresentationProps;
    removeActionLink?: LinkPresentationProps;
    deleteActionLink?: LinkPresentationProps;
    stateFieldWrapper?: FlexWrapperPresentationProps;
    documentsItemTitleWrapper?: InjectableCss;
    documentsTitle?: TypographyPresentationProps;
    documentsText?: TypographyPresentationProps;
    documentsFileWrapper?: InjectableCss;
    documentsTable?: DataTablePresentationProps;
    fileNameCell?: DataTableCellProps;
    submitButton?: ButtonPresentationProps;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    submitWrapper?: InjectableCss;
}

const commonLinkProps: LinkPresentationProps = {
    typographyProps: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    icon: {
        position: "left",
        iconProps: {
            size: 18,
            color: "text.link",
            css: css`
                margin-right: ${pxToRem(5)};
            `,
        },
    },
};

export const taxExemptionCertificateFormStyles: TaxExemptionCertificateFormStyles = {
    noResultsText: typographyGetNoResultsAltProps({ spaced: true }),
    errorsListTitle: {
        color: "danger.main",
        css: css`
            display: block;
            margin-bottom: 0.25em;
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
    errorsLink: {
        color: "text.main",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};

            &:focus {
                outline: ${pxToRem(5)} auto -webkit-focus-ring-color;
            }
        `,
        typographyProps: {
            underline: true,
        },
    },
    gridContainer: {
        gap: 80,
    },
    formGridItem: {
        width: [12, 12, 12, 7, 7],
    },
    filesGridItem: {
        width: [12, 12, 12, 5, 5],
    },
    fieldsFullGridItem: { width: 12 },
    fieldsHalfGridItem: { width: [12, 12, 6, 12, 6] },
    customerNameItem: { width: [12, 12, 8, 12, 8] },
    customerNumberItem: { width: [12, 12, 4, 12, 4] },
    filesItemWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    background: ${getColor("common.accent")};
                    width: 100%;
                    min-height: 80%;
                    ${breakpointValues([pxToRem(16), null, pxToRem(32), null, null], "padding")}
                `,
            },
            content: {
                css: css`
                    flex-direction: column;
                    align-items: stretch;
                    gap: ${pxToRem(32)};
                `,
            },
        },
    },
    stateFieldWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    width: 100%;
                `,
            },
            content: {
                css: css`
                    flex-direction: column;
                    gap: ${pxToRem(8)};
                `,
            },
        },
    },
    addActionLink: mergeProps<LinkPresentationProps>(commonLinkProps, {
        icon: {
            iconProps: {
                src: PlusCircleFill,
            },
        },
    }),
    removeActionLink: mergeProps<LinkPresentationProps>(commonLinkProps, {
        icon: {
            iconProps: {
                src: MinusCircleFill,
            },
        },
    }),
    deleteActionLink: mergeProps<LinkPresentationProps>(commonLinkProps, {
        icon: {
            iconProps: {
                src: TrashFill,
            },
        },
    }),
    documentsTitle: {
        variant: "h5",
    },
    documentsText: {
        variant: "p",
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    documentsFileWrapper: {
        css: css`
            width: 100%;
        `,
    },
    documentsTable: {
        css: css`
            ${x => x.theme.dataTable.defaultProps?.css}
            border: ${pxToRem(2)} solid ${getColor("text")};
        `,
    },
    fileNameCell: mergeProps<DataTableCellProps>(tableGetEllipsisCellProps(0), {
        css: css`
            > ${StyledButton}, > ${TypographyStyle} {
                ${breakpointValues(pxToRemArray([170, 380, 500, 260, 360]), "max-width")}
            }
        `,
    }),
    submitButton: {
        css: css`
            ${x => x.theme.button.primary.css}
            float: right;
            margin-top: 20px;

            ${breakpointValues(["100%", null, "auto", null, null], "width")}
        `,
    },
    successModal: { sizeVariant: "small" },
    messageTextGridItem: { width: 12 },
    buttonGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
            gap: ${pxToRem(8)};
        `,
    },
    submitWrapper: {
        css: css`
            border-bottom: 2px solid ${getColor("common.border")};
            padding-top: ${pxToRem(24)};
        `,
    },
};

export const TaxExemptionCertificateFormContext = React.createContext<ContextType>({
    validators: {},
});

const TaxExemptionCertificateForm = ({
    id,
    formVariant,
    history,
    currentSession,
    countries,
    currentBillTo,
    financeCompaniesDataView,
    loadTECFinanceCompanies,
    fileImportFormat,
    messageRequired,
    firstNameRequired,
    lastNameRequired,
    financeCompanyRequired,
    isFinanceCompanyDropdown,
    fileRequired,
    allowMultipleFiles,
    certificateData,
    submitButtonText,
    successMessage,
    linkBack,
    extendedStyles,
}: Props) => {
    const [styles] = useState(() => mergeToNew(taxExemptionCertificateFormStyles, extendedStyles));

    const isEditingCertificate = formVariant === "support";
    const isNewCertificate = formVariant === "new";

    const { firstName, lastName } = currentSession;
    const toasterContext = useContext(ToasterContext);
    const dispatch = useAppDispatch();
    const recaptchaRef: RefObject<ReCAPTCHA | null> = React.createRef();

    const [validators] = useState<{ [key: string]: Validator | undefined }>({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModelOpen, setIsModalOpen] = useState<boolean>(false);

    const [financeCompanyOptions, setFinanceCompanyOptions] = useState<OptionObject[]>([]);
    const [stateOptions, setStateOptions] = useState<OptionObject[]>([]);

    const [showStatesSelect, setShowStateSelect] = useState<boolean>(false);
    const [formState, setFormState] = useState<string>();
    const [statesList] = useState<any[]>([]);
    const [formMessage, setFormMessage] = useState<string>("");
    const [formFirstName, setFormFirstName] = useState<string>(firstName);
    const [formLastName, setFormLastName] = useState<string>(lastName);
    const [formFinanceCompany, setFormFinanceCompany] = useState<string>("");
    const [formPhoneNumber, setFormPhoneNumber] = useState<string>("");
    const [formDocuments, setFormDocuments] = useState<File[]>([]);
    const [formDocumentsData, setFormDocumentsData] = useState<string[]>([]);

    const [formMessageErrorMessage, setFormMessageErrorMessage] = useState<string | null>(null);
    const [formFirstNameErrorMessage, setFormFirstNameErrorMessage] = useState<string | null>(null);
    const [formLastNameErrorMessage, setFormLastNameErrorMessage] = useState<string | null>(null);
    const [formFinanceCompanyErrorMessage, setFormFinanceCompanyErrorMessage] = useState<string | null>(null);
    const [formDocumentsErrorMessage, setFormDocumentsErrorMessage] = useState<string | null>(null);
    const [formStateErrorMessage, setFormStateErrorMessage] = useState<string | null>(null);
    const [showFormErrors, setShowFormErrors] = useState(false);

    const forceUpdate = useForceUpdate();

    useEffect(() => {
        if (certificateData) {
            setFormState(certificateData?.state);
            setFormFinanceCompany(certificateData.financeCompanyName);
        }
    }, []);

    useEffect(() => {
        if (countries) {
            loadStatesList();
        }

        if (statesList.length > 0) {
            const options: OptionObject[] = statesList.map(state => ({
                optionText: `${state.name} (${state.abbreviation})`,
                optionValue: state.name,
            }));
            setStateOptions(options);
        }
    }, [countries]);

    useEffect(() => {
        if (!isFinanceCompanyDropdown || !isNewCertificate) {
            return;
        }

        if (!financeCompaniesDataView.value && !financeCompaniesDataView.isLoading) {
            loadTECFinanceCompanies({});
        }

        if (financeCompaniesDataView.value) {
            const options: OptionObject[] = financeCompaniesDataView.value.map(financeCompany => ({
                optionText: `${financeCompany.financeCompanyName} (${financeCompany.financeCompanyCode})`,
                optionValue: `${financeCompany.financeCompanyCode} ${financeCompany.financeCompanyName}`,
            }));
            setFinanceCompanyOptions(options);
        }
    }, [financeCompaniesDataView, isFinanceCompanyDropdown]);

    useEffect(() => {
        setShowFormErrors(
            Boolean(formMessageErrorMessage) ||
                Boolean(formFirstNameErrorMessage) ||
                Boolean(formLastNameErrorMessage) ||
                Boolean(formDocumentsErrorMessage) ||
                Boolean(formStateErrorMessage),
        );
    }, [
        formMessageErrorMessage,
        formFirstNameErrorMessage,
        formLastNameErrorMessage,
        formDocumentsErrorMessage,
        formStateErrorMessage,
    ]);

    const messageLabel = translate("Comments");
    const firstNameLabel = translate("First Name");
    const lastNameLabel = translate("Last Name");
    const soldToNameLabel = translate("Customer Sold-To Name");
    const soldToNumberLabel = translate("Customer Sold-To Number");
    const financeCompanyLabel = translate("Greif Company");
    const stateLabel = translate("State");
    const phoneNumberLabel = translate("Phone Number");

    const loadStatesList = () => {
        if (statesList.length === 0) {
            const unitedStates = countries!.find(x => x.abbreviation === "US");

            unitedStates?.states?.forEach(state => {
                if (certificateData) {
                    if (state.name.toLocaleLowerCase() !== certificateData?.state.toLocaleLowerCase()) {
                        statesList.push(state);
                    }
                }
                if (!certificateData) {
                    statesList.push(state);
                }
            });

            forceUpdate();
        }
    };

    const handleStateChange = (state?: string) => {
        if (state) {
            setFormState(state);
        }

        if (showFormErrors) {
            validateForm();
        }
    };

    const handleMessageChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setFormMessage(event.target.value);

        if (showFormErrors) {
            validateForm();
        }
    };

    const handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormFirstName(event.target.value);

        if (showFormErrors) {
            validateForm();
        }
    };

    const handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormLastName(event.target.value);

        if (showFormErrors) {
            validateForm();
        }
    };

    const handleFinanceCompanyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormFinanceCompany(event.target.value);

        if (showFormErrors) {
            validateForm();
        }
    };

    const handleFinanceCompanyDropdownChange = (financeCompany?: string) => {
        if (financeCompany) {
            setFormFinanceCompany(financeCompany);
        }

        if (showFormErrors) {
            validateForm();
        }
    };

    const handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormPhoneNumber(event.target.value);
    };

    const handleFileUpload: React.ChangeEventHandler<any> = event => {
        Array.from(event.target.files).forEach((file: any) => {
            formDocuments.push(file);
        });

        if (event.target.files[0] !== null) {
            const readers = [];

            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files[i];
                readers.push(readFileAsText(file));
            }
            Promise.all(readers).then((files: any) => {
                files.forEach((file: any) => {
                    formDocumentsData.push(file);
                });
            });
        }

        if (showFormErrors) {
            validateForm();
        }

        forceUpdate();

        event.target.value = null;
    };

    const readFileAsText = (file: File) => {
        return convertFileToBase64(file);
    };

    const handleDocumentRemove = (event: any, fileName: string) => {
        event.preventDefault();

        if (formDocuments.length === 1) {
            setFormDocuments([]);
            setFormDocumentsData([]);
        } else {
            const indexToRemove = formDocuments?.map(i => i.name).indexOf(fileName);
            formDocuments.splice(indexToRemove, 1);
            setFormDocuments([...formDocuments]);

            formDocumentsData.splice(indexToRemove, 1);
            setFormDocumentsData([...formDocumentsData]);
        }

        if (showFormErrors) {
            validateForm();
        }
    };

    const formReset = () => {
        setShowStateSelect(false);
        setFormState(isNewCertificate ? undefined : certificateData?.state);
        setFormMessage("");
        setFormFirstName(firstName);
        setFormLastName(lastName);
        setFormFinanceCompany("");
        setFormPhoneNumber("");
        setFormDocuments([]);
        setFormDocumentsData([]);
        setShowFormErrors(false);
    };

    const validateForm = () => {
        if (messageRequired) {
            setFormMessageErrorMessage(
                formMessage ? null : siteMessage("Field_Required", translate("Message")).toString(),
            );
        }

        if (firstNameRequired) {
            setFormFirstNameErrorMessage(
                formFirstName ? null : siteMessage("Field_Required", firstNameLabel).toString(),
            );
        }

        if (lastNameRequired) {
            setFormLastNameErrorMessage(formLastName ? null : siteMessage("Field_Required", lastNameLabel).toString());
        }

        if (financeCompanyRequired) {
            setFormFinanceCompanyErrorMessage(
                formFinanceCompany ? null : siteMessage("Field_Required", financeCompanyLabel).toString(),
            );
        }

        setFormDocumentsErrorMessage(
            formDocuments.length > 0 ? null : siteMessage("Field_Required", translate("Documents")).toString(),
        );

        setFormStateErrorMessage(formState ? null : siteMessage("Field_Required", stateLabel).toString());

        forceUpdate();

        const isValid =
            (messageRequired ? Boolean(formMessage) : true) &&
            (firstNameRequired ? Boolean(formFirstName) : true) &&
            (lastNameRequired ? Boolean(formLastName) : true) &&
            (financeCompanyRequired ? Boolean(formFinanceCompany) : true) &&
            formDocuments.length > 0 &&
            Boolean(formState);

        return isValid;
    };

    const formSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const widgetValidators: Validator[] = [];

        Object.keys(validators).forEach(key => {
            const validator = validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });

        const results = widgetValidators.map(v => v());

        if (!results.every(o => o)) {
            return;
        }

        if (!validateForm()) {
            setShowFormErrors(true);
            return;
        }

        const isReCaptchaValid = validateReCaptcha({
            location: "TECSubmitNew",
            recaptchaRef,
        });
        if (!isReCaptchaValid) {
            return;
        }

        const sentFiles: {
            data: string;
            fileName: string;
        }[] = [];
        formDocuments.forEach((file, index) => {
            const fileData = formDocumentsData[index].replace("-", "+").replace("_", "/").match(`(?<=base64,).*`);
            if (!fileData) {
                return;
            }

            sentFiles.push({ fileName: file.name, data: fileData[0] });
        });

        if (!sentFiles.length) {
            return;
        }

        setIsSubmitting(true);

        const formData = {
            tecNotificationModel: {
                taxExemptionCertificateId: certificateData?.id || null,
                message: formMessage,
                financeCompany: isNewCertificate ? formFinanceCompany : certificateData?.financeCompanyName,
                firstName: formFirstName,
                lastName: formLastName,
                phoneNumber: formPhoneNumber,
                state: formState,
                documents: sentFiles,
                isNewCertificate,
            },
        } as TECNotificationApiParameter;

        dispatch(
            submitTECNotificationForm({
                ...formData,
                onSuccess: () => {
                    dispatch(loadMessages({}));
                    setIsModalOpen(true);
                    setIsSubmitting(false);
                    formReset();
                },
                onError: () => {
                    toasterContext.addToast({
                        body: translate("TaxExemptionCertificate_FormSubmitError"),
                        messageType: "danger",
                        timeoutLength: 3000,
                    });
                },
                onComplete() {
                    this.onSuccess?.();
                },
            }),
        );
    };

    const modalCloseHandler = () => setIsModalOpen(false);

    const modalBackButtonClickHandler = () => {
        if (linkBack) {
            history.push(linkBack.url);
        }
    };

    return (
        <>
            {showFormErrors && (
                <InfosBox type="error">
                    <Typography {...styles.errorsListTitle}>{translate("Some errors have to be resolved:")}</Typography>
                    <UnorderedList {...styles.errorsList}>
                        {formStateErrorMessage && (
                            <ListItem {...styles.errorsListItem} role="alert">
                                {formStateErrorMessage}
                            </ListItem>
                        )}
                        {formFinanceCompanyErrorMessage && (
                            <ListItem {...styles.errorsListItem} role="alert">
                                {formFinanceCompanyErrorMessage}
                            </ListItem>
                        )}
                        {formMessageErrorMessage && (
                            <ListItem {...styles.errorsListItem} role="alert">
                                {formMessageErrorMessage}
                            </ListItem>
                        )}
                        {formFirstNameErrorMessage && (
                            <ListItem {...styles.errorsListItem} role="alert">
                                {formFirstNameErrorMessage}
                            </ListItem>
                        )}
                        {formLastNameErrorMessage && (
                            <ListItem {...styles.errorsListItem} role="alert">
                                {formLastNameErrorMessage}
                            </ListItem>
                        )}
                        {formDocumentsErrorMessage && (
                            <ListItem {...styles.errorsListItem} role="alert">
                                {formDocumentsErrorMessage}
                            </ListItem>
                        )}
                    </UnorderedList>
                </InfosBox>
            )}
            {!certificateData && isEditingCertificate ? (
                <StyledWrapper {...styles.noResultsContainer}>
                    <Typography {...styles.noResultsText}>{translate("No certificate found")}</Typography>
                </StyledWrapper>
            ) : (
                <form id={id} onSubmit={formSubmitHandler} noValidate style={{ width: "100%" }}>
                    <TaxExemptionCertificateFormContext.Provider value={{ validators }}>
                        <GridContainer {...styles.gridContainer}>
                            <GridItem {...styles.formGridItem}>
                                <GridContainer>
                                    <GridItem {...styles.customerNameItem}>
                                        <TextField
                                            label={soldToNameLabel}
                                            value={currentBillTo?.companyName || certificateData?.soldToBpName}
                                            required
                                            disabled
                                            title={currentBillTo?.companyName}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.customerNumberItem}>
                                        <TextField
                                            label={soldToNumberLabel}
                                            value={currentBillTo?.customerNumber}
                                            required
                                            disabled
                                        />
                                    </GridItem>
                                    <GridItem {...styles.fieldsHalfGridItem}>
                                        {isEditingCertificate && (
                                            <TextField
                                                label={financeCompanyLabel}
                                                value={certificateData?.financeCompanyName}
                                                required
                                                disabled
                                            />
                                        )}
                                        {isNewCertificate &&
                                            (isFinanceCompanyDropdown ? (
                                                <DynamicDropdown
                                                    label={financeCompanyLabel}
                                                    options={financeCompanyOptions}
                                                    placeholder={translate("Type to search a Greif company")}
                                                    isLoading={financeCompaniesDataView.isLoading}
                                                    selected={formFinanceCompany}
                                                    required={financeCompanyRequired}
                                                    onSelectionChange={handleFinanceCompanyDropdownChange}
                                                    error={showFormErrors && formFinanceCompanyErrorMessage}
                                                />
                                            ) : (
                                                <TextField
                                                    label={financeCompanyLabel}
                                                    value={formFinanceCompany}
                                                    onChange={handleFinanceCompanyChange}
                                                    placeholder={translate("Enter the Greif entity name")}
                                                    error={showFormErrors && formFinanceCompanyErrorMessage}
                                                    required={financeCompanyRequired}
                                                />
                                            ))}
                                    </GridItem>
                                    <GridItem {...styles.fieldsHalfGridItem}>
                                        <FlexWrapper {...styles.stateFieldWrapper}>
                                            {isEditingCertificate && (
                                                <TextField
                                                    label={stateLabel}
                                                    value={certificateData?.state}
                                                    required
                                                    disabled
                                                />
                                            )}
                                            {isNewCertificate && (
                                                <DynamicDropdown
                                                    label={stateLabel}
                                                    onSelectionChange={handleStateChange}
                                                    placeholder={translate("Type to search a state")}
                                                    options={stateOptions}
                                                    selected={formState}
                                                    required
                                                    error={showFormErrors && formStateErrorMessage}
                                                    disabled={showStatesSelect}
                                                />
                                            )}
                                        </FlexWrapper>
                                    </GridItem>
                                    <GridItem {...styles.fieldsFullGridItem}>
                                        <TextArea
                                            label={
                                                <FieldLabelAndTip
                                                    label={messageLabel}
                                                    optional
                                                    optionalLabel={translate("Message")}
                                                />
                                            }
                                            value={formMessage}
                                            onChange={handleMessageChange}
                                            error={showFormErrors && formMessageErrorMessage}
                                            required={messageRequired}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.fieldsHalfGridItem}>
                                        <TextField
                                            label={firstNameLabel}
                                            value={formFirstName}
                                            onChange={handleFirstNameChange}
                                            error={showFormErrors && formFirstNameErrorMessage}
                                            required={firstNameRequired}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.fieldsHalfGridItem}>
                                        <TextField
                                            label={lastNameLabel}
                                            value={formLastName}
                                            onChange={handleLastNameChange}
                                            error={showFormErrors && formLastNameErrorMessage}
                                            required={lastNameRequired}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.fieldsHalfGridItem}>
                                        <TextField
                                            label={
                                                <FieldLabelAndTip
                                                    label={phoneNumberLabel}
                                                    tip={translate(
                                                        "If you prefer us to call you back please leave your phone number.",
                                                    )}
                                                    optional
                                                />
                                            }
                                            onChange={handlePhoneNumberChange}
                                            placeholder={translate("555-555-5555")}
                                            value={formPhoneNumber}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                            <GridItem {...styles.filesGridItem}>
                                <FlexWrapper {...styles.filesItemWrapper}>
                                    <StyledWrapper {...styles.documentsItemTitleWrapper}>
                                        <Typography {...styles.documentsTitle}>
                                            {allowMultipleFiles
                                                ? translate("Tax Exemption Certificates")
                                                : translate("Tax Exemption Certificate")}
                                        </Typography>
                                        <Typography {...styles.documentsText}>
                                            {allowMultipleFiles
                                                ? siteMessage("TEC_MultipleFilesInstructions")
                                                : siteMessage("TEC_SingleFileInstructions")}
                                        </Typography>
                                        <Typography {...styles.documentsText}>
                                            {translate("File upload requirement: {0}", fileImportFormat)}
                                        </Typography>
                                    </StyledWrapper>
                                    <FileUpload
                                        label={translate("File upload")}
                                        onChange={handleFileUpload}
                                        accept={fileImportFormat}
                                        required={fileRequired}
                                        disabled={
                                            allowMultipleFiles ? formDocuments.length >= 5 : formDocuments.length === 1
                                        }
                                        multiple={allowMultipleFiles}
                                        error={showFormErrors && formDocumentsErrorMessage}
                                    />
                                    <StyledWrapper {...styles.documentsFileWrapper}>
                                        {formDocuments && formDocuments.length === 0 ? (
                                            <Typography {...styles.documentsText}>
                                                {translate("No document uploaded.")}
                                            </Typography>
                                        ) : (
                                            <DataTable {...styles.documentsTable}>
                                                <DataTableHead>
                                                    <DataTableHeader>
                                                        {allowMultipleFiles
                                                            ? translate("Uploaded Documents")
                                                            : translate("Uploaded Document")}
                                                    </DataTableHeader>
                                                    <DataTableHeader>{translate("Action")}</DataTableHeader>
                                                </DataTableHead>
                                                <DataTableBody>
                                                    {formDocuments?.map((document, index) => (
                                                        <DataTableRow key={`${document.name}_${index}`}>
                                                            <DataTableCell {...styles.fileNameCell}>
                                                                <Typography>{document.name}</Typography>
                                                            </DataTableCell>
                                                            <DataTableCell>
                                                                <Link
                                                                    {...styles.deleteActionLink}
                                                                    onClick={event =>
                                                                        handleDocumentRemove(event, document.name)
                                                                    }
                                                                >
                                                                    {translate("Delete")}
                                                                </Link>
                                                            </DataTableCell>
                                                        </DataTableRow>
                                                    ))}
                                                </DataTableBody>
                                            </DataTable>
                                        )}
                                    </StyledWrapper>
                                </FlexWrapper>
                            </GridItem>
                        </GridContainer>
                    </TaxExemptionCertificateFormContext.Provider>
                    <StyledWrapper {...styles.submitWrapper}>
                        <ReCaptcha location="TECSubmitNew" recaptchaRef={recaptchaRef} />
                        <Button {...styles.submitButton} type="submit" disabled={isSubmitting}>
                            {submitButtonText}
                        </Button>
                    </StyledWrapper>
                    <Modal
                        headline={translate("Message Sent")}
                        contentLabel={successMessage}
                        {...styles.successModal}
                        isOpen={isModelOpen}
                        handleClose={modalCloseHandler}
                        closeOnScrimClick={false}
                    >
                        <GridContainer {...styles.modalContainer}>
                            <GridItem {...styles.messageTextGridItem}>
                                <Typography {...styles.messageText}>{successMessage}</Typography>
                            </GridItem>
                            <GridItem {...styles.buttonGridItem}>
                                <Button
                                    {...styles.continueButton}
                                    variant="secondary"
                                    onClick={modalBackButtonClickHandler}
                                >
                                    {translate("Back to {0}", String(linkBack?.title))}
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </Modal>
                </form>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(TaxExemptionCertificateForm));
